import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';

const REVERSE_EXPERIMENT = 'rovo-ext_rovo_fps_use_rovo_config_reverse_exp';

/**
 * Whether the `useRovoConfig` combined-config path is active for this session.
 *
 * Wraps `rovo_fps_use_rovo_config` with a reverse experiment,
 * `rovo-ext_rovo_fps_use_rovo_config_reverse_exp` (ASIMO-4951). When the
 * experiment's `isEnabled` parameter is true the session behaves as though
 * `rovo_fps_use_rovo_config` were off, so the combined-config path falls back to
 * its legacy implementation. Otherwise, including for any session not enrolled,
 * `rovo_fps_use_rovo_config` decides on its own.
 *
 * This is a holdback: the treatment is the *older* code. It exists to attribute
 * a `searchCombinedConfig` latency regression that the original rollout could
 * not measure, because it did not include Rovo Extension metrics.
 *
 * The experiment is read first and unconditionally so that enrolled sessions log
 * an exposure whatever `rovo_fps_use_rovo_config` is set to. Uses the sanctioned
 * `isExperimentEnabled` API rather than the direct FeatureGates
 * experiment-value accessor, to satisfy the platform ratcheting rule.
 *
 * Every `rovo_fps_use_rovo_config` branch across `search-client` and
 * `search-page` must resolve to the same value within a session: the config
 * hook, its cache keys, and the bootstrap accessors that read its output are
 * not independently switchable. Always call this helper rather than reading
 * `fg('rovo_fps_use_rovo_config')` directly.
 *
 * Allocation must stay scoped to `targetApp = rovo_extension_web`. This helper
 * is shared by every product that consumes `search-page`, so an unscoped
 * allocation would move Confluence, Jira and Townsquare onto the legacy path
 * too.
 *
 * Experiment: https://switcheroo.atlassian.com/ui/gates/6bcebc20-9f2c-488e-ba8c-30a496c73c2b/key/rovo-ext_rovo_fps_use_rovo_config_reverse_exp
 */
export const isRovoFPSUseRovoConfigEnabled = (): boolean => {
	if (isExperimentEnabled(REVERSE_EXPERIMENT)) {
		return false;
	}
	return fg('rovo_fps_use_rovo_config');
};
